import {Component, OnInit} from '@angular/core';
import {CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent, CalendarView} from 'angular-calendar';
import { Subject } from 'rxjs';
import {isSameDay, isSameMonth} from 'date-fns';
import { EventService } from '../../services/event.service';
import Swal, {SweetAlertIcon} from 'sweetalert2';
import {NbDialogService} from '@nebular/theme';
import {CreateLogbookManteinenceComponent} from './create-logbook-manteinence/create-logbook-manteinence.component';
import {HelperService} from '../../services/helper.service';
import {environment} from '../../../environments/environment';
import {FilesService} from '../../services/files.service';
import {LogbookService} from '../../services/logbook.service';
import { StationService } from '../../services/stations.service';
import { ActivatedRoute } from '@angular/router';
import { AddEditEventAnnualProgramComponent } from './add-edit-event-annual-program/add-edit-event-annual-program.component';
import {SelectMonthReportComponent} from './select-month-report/select-month-report.component'
import { LocalDataSource } from 'ng2-smart-table';
import { AnnualProgramService } from '../../services/annual-program.service';
import { ActionsDefaultEvents } from './actions-default-events/actions-default-events.component'
import { AddEditEventCleaningAnnualProgramComponent } from './add-edit-event-cleaning-annual-program/add-edit-event-cleaning-annual-program.component';
import { CreateLogbookCleaningComponent } from './create-logbook-cleaning/create-logbook-cleaning.component';
import { SysUsersService } from '../../services/sys-users.service';
const moment = require('moment');

@Component({
  selector: 'ngx-annual-program',
  templateUrl: './annual-program.component.html',
  styleUrls: ['./annual-program.component.scss'],
})
export class AnnualProgramComponent implements OnInit {
  // GENERAL PARAMETERS
  user = {
    role: ''
  }
  logbook: any = {
    type: 1,
    activity_type: '',
    date: '',
    start_time: moment().format('H:mm'),
    end_time: moment().format('H:mm'),
    frequency: '',
    responsable: '',
    responsable_sign: '',
    external_staff: {
      provider: '',
      responsable: '',
    },
    fields: {
      description: '',
      element: '',
      typeActivity: '',
      dataTypeActivity: {},
      authorization_id: '',
    },
  };

  stationId: string;
  // CALENDAR PARAMS
  view: CalendarView = CalendarView.Month;
  activeDayIsOpen: boolean = false;
  CalendarView = CalendarView;
  viewDate: Date = new Date();
  events: CalendarEvent[] = [];
  dailyEventsCalendar: CalendarEvent[] = [];
  periodicityEventsCalendar: CalendarEvent[] = [];
  actions: CalendarEventAction[] = [
    {
      label: `<span class="hover-cursor-pointer ml-1"><img src="assets/icons/plus.png" width="18" alt="Agregar"></span>`,
      onClick: ({event}: { event: CalendarEvent }): void => {
        this.handleEvent('program', event);
      },
    },
    {
      label: `<span class="hover-cursor-pointer ml-1"><img src="assets/icons/show.png" width="18" alt="Mirar"></span>`,
      onClick: ({event}: { event: CalendarEvent }): void => {
        this.handleEvent('show', event);
      },
    },
  ];
  colors: any = {
    red: {
      primary: '#ec454f',
      secondary: '#FAE3E3',
    },
    blue: {
      primary: '#1e90ff',
      secondary: '#D1E8FF',
    },
    yellow: {
      primary: '#f19a1a',
      secondary: '#FDF1BA',
    },
    green: {
      primary: '#1aab8b',
      secondary: '#FDF1BA',
    },
  };
  // END CALENDAR PARAMS

  // TABLE EVENTS
  dataTableEvents: LocalDataSource;
  dataTableCleaningEvents: LocalDataSource;
  defaultTableEvents: LocalDataSource;
  defaultTableCleaningEvents: LocalDataSource;
  settings: any = {
    mode: 'external',
    edit: {
      editButtonContent: '<img src="assets/images/icons/edit.png" width="20px">',
    },
    delete: {
      deleteButtonContent: '<img src="assets/images/icons/swap.png" width="20px">',
    },
    actions: {
      columnTitle: 'Acciones',
      position: 'right',
      add: false,
      edit: true,
      delete: true
    },
    pager: {
      perPage: 50,
    },
    columns: {
      element: {
        title: 'Maquina/Equipo/Refacción/Elemento constructivo',
        width: '100px',
        filter: true,
      },
      type: {
        title: 'Evento',
        filter: true,
      },
      name: {
        title: 'Edificaciones/Area/Sistema/Instalación',
        filter: true,
      },
      frequency: {
        title: 'Frecuencia',
        filter: true,
      },
      date: {
        title: 'Fecha de inicio',
        filter: true,
      },
      enabled: {
        title: 'Estatus',
        filter: false,
        type: "html",
        valuePrepareFunction: (enabled) => {
          if (enabled) {
            return `<div class="d-flex"><span>Activo</span>  <img class="ml-2" width="20px" src="assets/images/icons/active.png"/></div>`
          } else {
            return `<div class="d-flex"><span>Inactivo</span>  <img class="ml-2" width="20px" src="assets/images/icons/inactive.png"/></div>`
          }
        }
      },
      finish_date_fill: {
        title: 'Fecha deshabilitado',
        filter: false,
        valuePrepareFunction: (finish_date_fill) => finish_date_fill,
      },
    },
    noDataMessage: 'Sin registros',
  };
  settingCleaningEvents: any = {
    mode: 'external',
    edit: {
      editButtonContent: '<img src="assets/images/icons/edit.png" width="20px">',
    },
    delete: {
      deleteButtonContent: '<img src="assets/images/icons/swap.png" width="20px">',
    },
    actions: {
      columnTitle: 'Acciones',
      position: 'right',
      add: false
    },
    pager: {
      perPage: 50,
    },
    columns: {
      name: {
        title: 'Nombre',
        width: '100px',
        filter: true,
      },
      frequency: {
        title: 'Frecuencia',
        filter: true,
      },
      date: {
        title: 'Fecha de inicio',
        filter: true,
      },
      enabled: {
        title: 'Estatus',
        filter: false,
        type: 'html',
        valuePrepareFunction: (enabled) => {
          if (enabled) {
            return `<div class="d-flex"><span>Activo</span>  <img class="ml-2" width="20px" src="assets/images/icons/active.png"/></div>`
          } else {
            return `<div class="d-flex"><span>Inactivo</span>  <img class="ml-2" width="20px" src="assets/images/icons/inactive.png"/></div>`
          }
        }
      },
      finish_date_fill: {
        title: 'Fecha deshabilitado',
        filter: false,
        valuePrepareFunction: (finish_date_fill) => finish_date_fill,
      },
    },
    noDataMessage: 'Sin registros',
  };
  settingDefaultEvents: any = {
    mode: 'external',
    actions: false,
    columns: {
      numeral: {
        title: 'Numeral: División NOM-005-ASEA-2016',
        filter: true,
      },
      area: {
        title: 'Área',
        filter: true,
      },
      activity: {
        title: 'Actividad',
        filter: true,
      },
      periodicity: {
        title: 'Frecuencia',
        filter: true,
      },
      default_event_checked: {
        title: 'Status',
        filter: true,
        valuePrepareFunction: (enabled) => enabled ? 'Calendarizado' : 'No agregado',
      },
      actions: {
        add: false,
        edit: false,
        delete: false,
        title: 'Acciones',
        type: 'custom',
        valuePrepareFunction: (cell, row) => ({ ...row, role_logged_user: this.user.role }),
        renderComponent: ActionsDefaultEvents,
        onComponentInitFunction: (instance) => {
          instance.save.subscribe(event => {
            this.addEvent(event);
          });
        },
        filter: false,
      },
    },
    pager: {
      perPage: 15,
    },
    noDataMessage: 'Sin registros',
  };
  settingDefaultCleaningEvents: any = {
    mode: 'external',
    actions: false,
    columns: {
      numeral: {
        title: 'Numeral: División NOM-005-ASEA-2016',
        filter: true,
      },
      area: {
        title: 'Área',
        filter: true,
      },
      activity: {
        title: 'Actividad',
        filter: true,
      },
      periodicity: {
        title: 'Periodicidad',
        filter: true,
      },
      default_event_checked: {
        title: 'Status',
        filter: true,
        valuePrepareFunction: (enabled) => enabled ? 'Calendarizado' : 'No agregado',
      },
      actions: {
        add: false,
        edit: false,
        delete: false,
        title: 'Acciones',
        type: 'custom',
        valuePrepareFunction: (cell, row) => ({ ...row, role_logged_user: this.user.role }),
        renderComponent: ActionsDefaultEvents,
        onComponentInitFunction: (instance) => {
          instance.save.subscribe(event => {
            this.addCleaningEvent(event);
          });
        },
        filter: false,
      },
    },
    pager: {
      perPage: 15,
    },
    noDataMessage: 'Sin registros',
  };
  // END TABLE EVENTS

  auxYearPeriodicityFill = 5;

  refresh: Subject<any> = new Subject();
  // START EVENTS LOGIC
  stationEvents = [];
  stationCleaningEvents = [];
  logbooks = [];
  formatDate = 'YYYY/MM/DD';


  startDate =  moment().format('YYYY/MM/') + '01';
  endDate = moment().format('YYYY/MM/') + moment().daysInMonth();
  attrAux = {
    loading: false,
  };
  dataLoaded = false;

  constructor(
    private dialogService: NbDialogService,
    private helperService: HelperService,
    private logbookService: LogbookService,
    private eventService: EventService,
    private dialog: NbDialogService,
    private fileService: FilesService,
    private stationService: StationService,
    private annualProgramService: AnnualProgramService,
    private route: ActivatedRoute,
    private userService: SysUsersService,
  ) {
    this.stationId =  this.route.snapshot.params.stationId;

    this.stationService.change.subscribe(async (station: any) => {
      this.stationId = station;
      this.ngOnInit();
    });
  }

  async ngOnInit() {
    this.stationService.checkIfStationIdOrRefirect();
    this.init();
  }

  async init() {
    await this.resetData();
    this.attrAux.loading = true;
    this.getDefaultEvents();
    this.getDefaultCleaningEvents();
    await Promise.all([this.setUser(), this.getStationEvents(), this.getStationCleaningEvents(), this.getLogbooksByIntervalDate()]);
    this.settings.actions.edit = this.user.role !== 'viewAndDownloadOnly';
    this.settings.actions.delete = this.user.role !== 'viewAndDownloadOnly';
    this.settingCleaningEvents.actions.edit = this.user.role !== 'viewAndDownloadOnly';
    this.settingCleaningEvents.actions.delete = this.user.role !== 'viewAndDownloadOnly';
    await this.formatDataCalendarDailyActivities();
    await this.formatDataCalendarPeriodicityActivities();
    this.attrAux.loading = false;
  }

  async setUser () {
    const [error, response] = await this.userService.getProfileV2();
    if (error) return error;
    this.user = response.data;
  }

  async getDefaultEvents() {
    const [err, response]: any = await this.annualProgramService.getDefaultEvents(this.stationId);
    if (err) return this.alert('Oops, intenta más tarde', 'error', 'Al cargar preferencias');

    this.defaultTableEvents = response.data;
  }

  async getDefaultCleaningEvents() {
    const [err, response]: any = await this.annualProgramService.getDefaultCleaningEvents(this.stationId);
    if (err) return this.alert('Oops, intenta más tarde', 'error', 'Al cargar preferencias');
    this.defaultTableCleaningEvents = response;
  }

  async getStationEvents() {
    const [err, response]: any = await this.eventService.getStationEvents(this.stationId);
    if (err) return this.alert('Oops, intenta más tarde', 'error', 'Al cargar preferencias');
    this.stationEvents = response.data
    //console.log(this.stationEvents)
    this.dataTableEvents = response.data.map(event => {
      return {
        ...event,
        frequency: event.frequency === 'custom'
          ? `Cada ${event.custom_frequency.number} ${event.custom_frequency.frequency}`
          : event.frequency
      }
    })
  }

  async getStationCleaningEvents() {
    const [err, response]: any = await this.eventService.getStationCleaningEvents(this.stationId);
    if (err) return this.alert('Oops, intenta más tarde', 'error', 'Al cargar preferencias');
    //console.log('Cleaning events', response.data)
    this.stationCleaningEvents = response.data
    this.dataTableCleaningEvents = response.data.map(event => {
      return {
        ...event,
        frequency: event.frequency === 'custom'
          ? `Cada ${event.custom_frequency.number} ${event.custom_frequency.frequency}`
          : event.frequency
      }
    })
  }

  async getLogbooksByIntervalDate() {
    const [err, {data: result}] = await this.logbookService.getLogbookAnnualProgramByIntervalDate(
      this.stationId,
      moment(this.startDate).format('YYYY-MM-DD'),
      moment(this.endDate).format('YYYY-MM-DD')
    );
    if (err) return this.alert('Error', 'error', 'Al intentar obtener bitacoras');
    this.logbooks = result;
  }

  getDailyStationEvents() {
    return this.stationEvents.filter(event => event.frequency.toLowerCase() === 'diario');
  }

  getDailyStationCleaningEvents() {
    return this.stationCleaningEvents.filter(event => event.frequency.toLowerCase() === 'diario');
  }

  getPeriodicityEvents() {
    const calendarEvents = [...this.stationEvents, ... this.stationCleaningEvents];
    return calendarEvents.filter(event => {
      if (event.frequency.toLowerCase() === 'custom') {
        if (isNaN(parseInt(event.custom_frequency.number))) event.frequency = 'none'
        else if (event.custom_frequency.frequency) event.custom_frequency.number = parseInt(event.custom_frequency.number)
        else event.frequency = 'none'
      }
      return event.frequency.toLowerCase() !== 'diario'
    });
  }

  async formatDataCalendarDailyActivities() {

    this.events = [];
    const numberDaysMonth = moment(this.startDate).daysInMonth();
    const monthSelected = moment(this.startDate).format('MM');
    const yearSelected = moment(this.startDate).format('YYYY');
    const dateToday = moment().format(this.formatDate);


    const maintenanceEvents = this.getDailyStationEvents();
    const maintenanceCleaningEvents = this.getDailyStationCleaningEvents();
    const calendarEvents = [...maintenanceEvents, ... maintenanceCleaningEvents];
    for (const event of calendarEvents) {
      for (let day = 1; day <= numberDaysMonth; day++) {
        const dateGenerated = moment(`${monthSelected}/${day}/${yearSelected}`).format(this.formatDate);

        let continueShowEvent = true;
        if (event.finish_date_fill) {
          const finish_date_fill_formatted = moment(event.finish_date_fill).format(this.formatDate);
          if (finish_date_fill_formatted <= dateGenerated) continueShowEvent = false
        }
        // 5N5MjKUEmbEJcbas2PsR - Z GAS COMPANY SA DE CV - ZGC
        if (this.stationId === '5N5MjKUEmbEJcbas2PsR' && moment(event.date).format(this.formatDate) > dateGenerated) {
          continueShowEvent = false
        }

        if (continueShowEvent) {
          const canCreate = dateToday >= dateGenerated;
          const isCleaningEvent = event.fields ? true: false
          let isProgramed;
          if (isCleaningEvent) {
            isProgramed = this.logbooks.find(logbook => moment(logbook.date).format(this.formatDate) === dateGenerated && logbook.cleaning_event_id === event.id);
          } else {
            isProgramed = this.logbooks.find(logbook => moment(logbook.date).format(this.formatDate) === dateGenerated && logbook.event_id === event.id);
          }
          let title = '';
          if (isProgramed) {
            title = this.capitalizeText(event.element + ' ' + event.name) + ' - ' + this.capitalizeText(event.frequency);
            title = event.fields ? this.capitalizeText(event.name) : title;
            this.events.push({
              start: new Date(`${monthSelected}/${day}/${yearSelected}`),
              title,
              cssClass: 'py-1',
              color: this.colors.green,
              actions: [this.actions[1]],
              meta: { is_programmed: true, logbook_id: isProgramed.id, is_cleaning_logbook: isCleaningEvent }
            });
          } else {
            title = this.capitalizeText(event.element + ' ' + event.name + ' ' + event.type) + ' - ' + this.capitalizeText(event.frequency);
            title = event.fields ? this.capitalizeText(event.name) : title;
            this.events.push({
              start: new Date(`${monthSelected}/${day}/${yearSelected}`),
              title,
              color: this.colors.red,
              cssClass: 'py-1',
              actions: (canCreate && this.user.role !== 'viewAndDownloadOnly') ? [this.actions[0]] : [],
              meta: { is_programmed: false, event_id: event.id, is_cleaning_logbook: isCleaningEvent }
            });
          }
        } // validation date
      }// days in month
    }// daily events
  }


  async programLogbook(canEdit: boolean = true) {
    const dataAux: any = {}
    if (this.logbook.id) {
      dataAux.start_time = this.logbook.start_time
      dataAux.end_time = this.logbook.end_time
    } else {
      dataAux.start_time = moment().format('H:mm')
      dataAux.end_time = moment().format('H:mm')
    }
    console.log(this.logbook)
    this.dialogService.open(CreateLogbookManteinenceComponent, {
      hasScroll: true,
        context: {
        stationId: this.stationId,
        logbook: { ...this.logbook, ...dataAux },
        canEdit,
      },
    }).onClose.subscribe(programLogbook => {
      return programLogbook ? this.ngOnInit() : this.resetData();
    });
  }

  async programCleaningLogbook(canEdit: boolean = true) {
    const dataAux: any = {}
    if (this.logbook.id) {
      dataAux.start_time = this.logbook.start_time
      dataAux.end_time = this.logbook.end_time
    } else {
      dataAux.start_time = moment().format('H:mm')
      dataAux.end_time = moment().format('H:mm')
    }
    this.dialogService.open(CreateLogbookCleaningComponent, {
      hasScroll: true,
        context: {
        stationId: this.stationId,
        logbook: { ...this.logbook, ...dataAux },
        canEdit,
      },
    }).onClose.subscribe(programLogbook => {
      return programLogbook ? this.ngOnInit() : this.resetData();
    });
  }

  async formatDataCalendarPeriodicityActivities() {
    // 'quinquenal', 'mensual', 'trimestral', 'cuatrimestral', 'semestral', 'anual'
    for (const event of this.getPeriodicityEvents()) {
      switch (event.frequency.toLowerCase()) {
        case 'semanal':
          await this.fillPeriodicityDataIntoCalendarView(event, 7, 'days');
          break;
        case 'quinquenal':
        case 'quincenal':
          await this.fillPeriodicityDataIntoCalendarView(event, 15, 'days');
          break;
        case 'mensual':
          await this.fillPeriodicityDataIntoCalendarView(event, 1, 'month');
          break;
        case 'bimestral':
          await this.fillPeriodicityDataIntoCalendarView(event, 2, 'month');
          break;
        case 'trimestral':
          await this.fillPeriodicityDataIntoCalendarView(event, 3, 'month');
          break;
        case 'cuatrimestral':
          await this.fillPeriodicityDataIntoCalendarView(event, 4, 'month');
          break;
        case 'semestral':
          await this.fillPeriodicityDataIntoCalendarView(event, 6, 'month');
          break;
        case 'anual':
        case 'anual (por recomendación)':
          await this.fillPeriodicityDataIntoCalendarView(event, 1, 'year');
          break;
        case 'custom':
          await this.fillPeriodicityDataIntoCalendarView(event, event.custom_frequency.number, event.custom_frequency.frequency);
          break;
        default:
          await this.fillPeriodicityDataIntoCalendarView(event, 0, 'year');
          break;
      }
    }
  }

  async fillPeriodicityDataIntoCalendarView(event: any, add: number, type: string) {
    const dateActivity = moment(event.date);
    const currentDate = moment();
    let afterDate = dateActivity.format(this.formatDate);
    let auxDate = currentDate;
    const whenYearsFilling = Number(dateActivity.add(this.auxYearPeriodicityFill, 'year').year());
    let continueFilling = true;
    do {
      let continueShowEvent = true;
      // const canCreate = currentDate.format(this.formatDate) >= afterDate;
      const copyFrequency = event.frequency === 'custom' ? 'Cada ' + event.custom_frequency.number + ' ' + event.custom_frequency.frequency : event.frequency;
      const title = event.fields ? event.name : this.capitalizeText(event.name + ' ' + event.element + ' - ') + this.capitalizeText(copyFrequency);
      const isCleaningEvent = event.fields ? true: false
      let isProgrammed: any;
      if (isCleaningEvent) {
        isProgrammed = this.logbooks.find(logbook => moment(logbook.date).format(this.formatDate) === afterDate && logbook.cleaning_event_id === event.id);
      } else {
        isProgrammed = await this.logbooks.find(logbook => moment(logbook.date).format(this.formatDate) === afterDate && logbook.event_id === event.id );
      }
      if (event.finish_date_fill) {
        const finish_date_fill_formatted = moment(event.finish_date_fill).format(this.formatDate);
        if (finish_date_fill_formatted <= afterDate) continueShowEvent = false
      }
      if (continueShowEvent) {
        if (isProgrammed) {
          this.events.push({
            start: (isProgrammed.fields.date_realization) ? new Date(moment(isProgrammed.fields.date_realization).format(this.formatDate)) : new Date(afterDate),
            title,
            color: this.colors.green,
            cssClass: 'py-1',
            actions: [this.actions[1]],
            meta: { is_programmed: true, logbook_id: isProgrammed.id, is_cleaning_logbook: event.fields ? true: false }
          });
        } else {
          this.events.push({
            start: new Date(afterDate),
            title,
            color: this.colors.yellow,
            cssClass: 'py-1',
            // remove true for can create future dates
            actions: (this.user.role !== 'viewAndDownloadOnly') ? [this.actions[0]] : [],
            meta: { is_programmed: false, event_id: event.id, is_cleaning_logbook: event.fields ? true: false }
          });
        }
    } // withStopFill
      continueFilling = add ? Number(auxDate.year()) < whenYearsFilling : false
      auxDate = moment(afterDate).add(add, type);
      afterDate = auxDate.format(this.formatDate);
      if (!continueShowEvent) continueFilling = false
    } while (continueFilling);
  }

  setView(view: CalendarView) {
    this.view = view;
  }

  closeOpenMonthViewDay(evt: any) {
    this.startDate = moment(evt).format('YYYY/MM/') + '01';
    this.endDate = moment(evt).format('YYYY/MM/') + moment(evt).daysInMonth();
    this.activeDayIsOpen = false;
    return this.ngOnInit();
  }

  async handleEvent(action: string, event: any, record_init_periodicity: boolean = false) {
    if (action === 'program') {
      if (!event.meta.is_cleaning_logbook) {
        const findEvent = this.stationEvents.find(eventStation => eventStation.id === event.meta.event_id)
        if (!findEvent) return this.alert('Error', 'error', 'No se encontro mock de evento');
        if (record_init_periodicity) this.logbook.fields.record_init_periodicity = true;
        this.logbook.frequency = findEvent.frequency;
        this.logbook.event_id = findEvent.id;
        this.logbook.fields.activity = findEvent.activity
        this.logbook.fields.element = findEvent.element;
        this.logbook.fields.description = findEvent.name;
        this.logbook.activity_type = findEvent.type;
        this.logbook.date = event.start
        await this.programLogbook();
      } else {
        const findEvent = this.stationCleaningEvents.find(eventStation => eventStation.id === event.meta.event_id)
        if (!findEvent) return this.alert('Error', 'error', 'No se encontro mock de evento');
        if (record_init_periodicity) this.logbook.fields.record_init_periodicity = true;
        this.logbook.event_id = findEvent.id;
        this.logbook.date = event.start
        this.logbook.frequency = findEvent.period;
        this.logbook.fields = findEvent.fields;
        this.logbook.type = 10;
        await this.programCleaningLogbook(findEvent);
      }
    }
    if (action === 'show') {
      this.logbook = await this.logbooks.find(item => item.id === event.meta.logbook_id);
      if (!this.logbook) return this.alert('Error', 'error', 'No se encontro bitacora');

      if (this.logbook.cleaning_event_id) {
        await this.programCleaningLogbook(false);
      } else {
        await this.programLogbook(false);
      }
    }
  }

  async editProgramEvent(program: any) {
    this.attrAux.loading = true;
    const [err] = await this.eventService.updateEvent(program.eventStation.id, { date: program.date });
    this.attrAux.loading = false;
    if (err) return this.alert('Oops, intenta más tarde', 'error', 'Al tratar de editar el evento');
    await this.alert('Evento actualizado');
    await this.ngOnInit();
  }

  async deleteProgramEvent(program: any) {
    this.attrAux.loading = true;
    const [err] = await this.eventService.deleteEvent(program.eventStation.id);
    this.attrAux.loading = false;
    if (err) return this.alert('Oops, intenta más tarde', 'error', 'Al tratar de eliminar el evento');
    await this.alert('Evento eliminado');
    await this.ngOnInit();
  }

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      this.viewDate = date;
      this.activeDayIsOpen = !((isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) || events.length === 0);
    }
  }

  eventTimesChanged({ event, newStart, newEnd }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map(iEvent => {
      if (iEvent === event) return { ...event, start: newStart, end: newEnd };
      return iEvent;
    });
    this.handleEvent('Dropped or resized', event);
  }

  capitalizeText (input: string) {
    return input && input.length ? (input.charAt(0).toUpperCase() + input.slice(1).toLowerCase()) : input;
  }

  async resetData() {
    this.attrAux = {
      loading: false,
    };
    this.logbook = {
      type: 1,
      activity_type: '',
      date: '',
      start_time: moment().format('H:mm'),
      end_time: moment().format('H:mm'),
      frequency: '',
      responsable: '',
      responsable_sign: '',
      external_staff: {
        provider: '',
        responsable: '',
      },
      fields: {
        description: '',
        element: '',
        typeActivity: '',
        dataTypeActivity: {},
        authorization_id: '',
      },
    };
  }

  addEvent(defaultEvent: any = false) {
    let contextData: any = { stationId: this.stationId };

    if (defaultEvent) {
      contextData = { ...contextData, defaultEvent, addDefaultEvent: true }
    }

    this.dialog.open(AddEditEventAnnualProgramComponent, {
      hasScroll: true,
      context: contextData
    }).onClose.subscribe(response => { if (response) this.ngOnInit() });
  }

  addCleaningEvent(defaultEvent: any = false) {
    let contextData: any = { stationId: this.stationId };

    if (defaultEvent) {
      contextData = { ...contextData, defaultEvent, addDefaultEvent: true }
    }

    this.dialog.open(AddEditEventCleaningAnnualProgramComponent, {
      hasScroll: true,
      context: contextData
    }).onClose.subscribe(response => { if (response) this.ngOnInit() });
  }

  editEvent (event) {
    this.dialog.open(AddEditEventAnnualProgramComponent, {
      hasScroll: true,
      context: { stationId: this.stationId, edit: true, event: event.data }
    }).onClose.subscribe(response => { if (response) this.ngOnInit() });
  }

  editCleaningEvent (event) {
    this.dialog.open(AddEditEventCleaningAnnualProgramComponent, {
      hasScroll: true,
      context: { stationId: this.stationId, edit: true, event: event.data }
    }).onClose.subscribe(response => { if (response) this.ngOnInit() });
  }

  async selectMonth() {
    this.dialog.open(SelectMonthReportComponent, {
      hasScroll: true,
      context: { stationId: this.stationId }
    }).onClose.subscribe(response => response);
  }

  async downloadFile(name: string) {
    this.attrAux.loading = true;
    const date = moment(this.startDate).format('YYYY-MM-DD');
    const url = `${environment.baseEndpoint}/annualProgram/station/${this.stationId}/report/v2?date=${date}`;
    await this.fileService.downloadFile(url, name);
    this.attrAux.loading = false;
  }

  async remove(program: any) {
    Swal.fire({
      title: (!program.data.enabled)
        ? '¿Estás seguro de activar este evento?'
        : '¿Estás seguro de deshabilitar este evento?',
      text: (!program.data.enabled)
        ? 'El evento pasará a tener el estatus de "Activo" y restaurará los registros futuros a partir de la fecha ' + program.data.finish_date_fill
        : 'El evento pasará a tener el estatus de "Deshabilitado" y en el calendario se seguiran mostrando los registros anteriores apartir de la fecha de hoy',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Estoy seguro',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.reallyRemove(program);
      }
    })
  }

  async removeCleaningEvent(program: any) {
    Swal.fire({
      title: (!program.data.enabled)
        ? '¿Estás seguro de activar este evento?'
        : '¿Estás seguro de deshabilitar este evento?',
      text: (!program.data.enabled)
        ? 'El evento pasará a tener el estatus de "Activo" y restaurará los registros futuros a partir de la fecha ' + program.data.finish_date_fill
        : 'El evento pasará a tener el estatus de "Deshabilitado" y en el calendario se seguiran mostrando los registros anteriores apartir de la fecha de hoy',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Estoy seguro',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.reallyRemoveCleaningEvent(program);
      }
    })
  }

  async reallyRemove(event) {
    this.attrAux.loading = true;
    const [error] = await this.eventService.disabledOrEnabled(event.data.id)
    this.attrAux.loading = false;
    if (error) return this.alert('Oops, intenta más tarde', 'error', 'Al tratar de eliminar el evento');
    await this.alert('Éxito', 'success', 'Evento actualizado');
    await this.ngOnInit();
  }

  async reallyRemoveCleaningEvent(event) {
    this.attrAux.loading = true;
    const [error] = await this.eventService.disabledOrEnabledCleaningEvent(event.data.id)
    this.attrAux.loading = false;
    if (error) return this.alert('Oops, intenta más tarde', 'error', 'Al tratar de eliminar el evento');
    await this.alert('Éxito', 'success', 'Evento actualizado');
    await this.ngOnInit();
  }

  async alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    await Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  createEvent(event) {
    if (event.action === 'addEvent') {
      this.addEvent(event.data);
    }
  }

  createCleaningEvent(event) {
    if (event.action === 'addEvent') {
      this.addCleaningEvent(event.data)
    }
  }
}
